import { Flex, Heading } from "@aws-amplify/ui-react";

const HealthRecordsDocumentImagesPage = () => {
  return (
    <Flex
      gap="24px"
      direction="column"
      width="unset"
      minWidth={650}
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
            <Heading
        width="unset"
        height="unset"
        shrink="0"
        level="3"
        children="MRI (Magnetic Resonance Imaging)"
      ></Heading>
          <img width={'auto'} height={450} src='/images/mri-image1.jpg' />
          <img width={'auto'} height={300} src='/images/mri-image2.jpg' />
          <img width={'auto'} height={300} src='/images/mri-image3.jpg' />
          <img width={'auto'} height={300} src='/images/mri-image4.jpg' />
    </Flex>
  );
};

export default HealthRecordsDocumentImagesPage;
